import { useIntl } from 'react-intl';
import React, { useMemo } from 'react';
import { messages } from '../messages';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { getEffect } from '../observationUtils';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { getTestProps } from '../../../../../../util/testProps';

export const structuralVariantTestIds = {
  gene: 'structuralVariant-gene',
  effect: 'structuralVariant-effect',
};

export interface StructuralVariantProps {
  gene: string;
  observation: fhir.Observation;
}

export const StructuralVariant = (props: StructuralVariantProps) => {
  const { formatMessage } = useIntl();
  const { gene, observation } = props;

  const effect = useMemo(() => getEffect(observation), [observation]);

  return (
    <>
      {gene && (
        <Tooltip title={formatMessage(messages.targetGene)}>
          <Text size="subbody" {...getTestProps(structuralVariantTestIds.gene)}>
            {gene}
          </Text>
        </Tooltip>
      )}
      {/* @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks. */}
      {messages[effect] && (
        <Tooltip title={formatMessage(messages.effect)}>
          <Text
            size="subbody"
            {...getTestProps(structuralVariantTestIds.effect)}
          >
            {/* @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks. */}
            {formatMessage(messages[effect])}
          </Text>
        </Tooltip>
      )}
    </>
  );
};
